import React, { useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Home from './Home';
import Typography from '@mui/material/Typography';

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import './index.css'

import { useNavigate } from 'react-router-dom'
import colorsv1 from '../config/colorsv1';
import { TextField } from '@mui/material';
import PolicyCard from '../components/PolicyCard';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import StatusCheck from '../components/StatusCheck';
import { getUserDetails, triggerAadhaarOtp, validateAadhaarOtp, validatePAN } from '../actions/policyAction';
import { useDispatch, useSelector } from 'react-redux';
import { canProceed } from '../helper/canProceed';
import { getTitle } from '../helper/formatter';
import { pathOr } from 'ramda';
import { getStepsForNav } from '../helper/steps';


const AadhaarVerification = (props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const policy = useSelector(state => state.Auth.policy)
  const [info, setInfo] = useState({
    aadhaarNumber: '',
  });
  const [showOtp, setShowOtp] = useState(false);

  const [requestId, setRequestId] = useState("");
  const updateForm = (val, name) => {
    setInfo({
      ...info,
      [name]: val,
    });
  };
  const [error, setError] = useState({
    aadhaarNumber: {
      hasError: true,
      errorMessage: '',
    },
    aadhaarOtp: {
      hasError: false,
      errorMessage: '',
    }
  });

  const handleAadhaarVerification = async () => {
    const body = {
      aadhaarNumber: info.aadhaarNumber,
      otp: info.aadhaarOtp,
    };
    const status = await dispatch(
      triggerAadhaarOtp(body),
    );
    if (status) {
      setRequestId(status.requestId)
      setShowOtp(true)
    }
  };
  
  const handleAadhaarVerificationOtp = async () => {
    const body = {
      requestId,
      otp: info.aadhaarOtp,
    };
    const status = await dispatch(
      validateAadhaarOtp(body),
    );
    if (status) {
      navigate("/upload")
    }
  }

  const handleAuthMe = async () => {
    const status = await dispatch(
      getUserDetails(),
    );

  }
  useEffect(() => {
    handleAuthMe();
  }, [dispatch]);

  const steps = useSelector(state => state.Auth.steps)
  useEffect(() => {
    const step = getStepsForNav(steps, policy, 'kyc');
    if (step != '')
      navigate(step)
  }, [dispatch, steps])



  const panRef = useRef(null);
  const mobileRef = useRef(null);
  const dobRef = useRef(null);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (event.target === panRef.current) {
        mobileRef.current.focus();
      }
      if (event.target === mobileRef.current) {
        dobRef.current.focus();
      }
    }
  };

  return (
    <Home>
      <Container component="main" maxWidth="sm" sx={{ mb: 4, mt: 10 }}>
        <Typography
          component="h2"
          variant="h5"
          color="inherit"
          noWrap
          sx={{ flex: 1 }}
          className="title"
        >
          {getTitle(pathOr('', ['journey'], policy))}
        </Typography>
        <Paper variant="outlined" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>



          <PolicyCard />


          <div className='body mediumFont' style={{ marginTop: '24px' }}>{"Complete your KYC"}</div>

          <StatusCheck />

          <div style={{ background: colorsv1.grey[200], padding: '24px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <TextField
                  required
                  inputRef={panRef}
                  onKeyDown={handleKeyDown}
                  id="aadhaarNumber"
                  name="aadhaarNumber"
                  label="Enter Aadhaar number"
                  fullWidth
                  autoComplete="given-name"
                  variant="standard"
                  inputProps={{
                    maxLength: 12,
                    style: {
                      textTransform: 'uppercase',
                    },
                  }}
                  disabled={showOtp}
                  error={error.aadhaarNumber.hasError}
                  helperText={error.aadhaarNumber.errorMessage}
                  onChange={(event) => {
                    updateForm(event.target.value, 'aadhaarNumber');
                    if (!new RegExp('^[0-9]{12}$').test(event.target.value.toLocaleUpperCase())) {
                      setError({
                        ...error,
                        aadhaarNumber: {
                          hasError: true,
                          errorMessage: 'Enter valid Aadhaar number',
                        },
                      })
                    } else {

                      setError({
                        ...error,
                        aadhaarNumber: {
                          hasError: false,
                          errorMessage: '',
                        },
                      })
                    }
                  }}
                />
              </Grid>
              {showOtp && (
                <Grid item xs={12} sm={12}>
                  <TextField
                    required
                    inputRef={panRef}
                    onKeyDown={handleKeyDown}
                    id="aadhaarOtp"
                    name="aadhaarOtp"
                    label="Enter Aadhaar OTP"
                    fullWidth
                    autoComplete="given-name"
                    variant="standard"
                    inputProps={{
                      maxLength: 12,
                      style: {
                        textTransform: 'uppercase',
                      },
                    }}

                    error={error.aadhaarOtp.hasError}
                    helperText={error.aadhaarOtp.errorMessage}
                    onChange={(event) => {
                      updateForm(event.target.value, 'aadhaarOtp');
                      if (!new RegExp('^[0-9]{6}$').test(event.target.value.toLocaleUpperCase())) {
                        setError({
                          ...error,
                          aadhaarOtp: {
                            hasError: true,
                            errorMessage: 'Enter valid OTP',
                          },
                        })
                      } else {

                        setError({
                          ...error,
                          aadhaarOtp: {
                            hasError: false,
                            errorMessage: '',
                          },
                        })
                      }
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </div>
          {!showOtp && (
          <div style={{ marginTop: '24px', textAlign: 'center', marginBottom: '32px' }}>
            <Button disabled={canProceed(error)} onClick={() => { handleAadhaarVerification(); }} variant="contained" color="success" size="medium" sx={{ width: 260, padding: 1, margin: 2 }}>SUBMIT</Button>
          </div>
          )}
           {showOtp && (
          <div style={{ marginTop: '24px', textAlign: 'center', marginBottom: '32px' }}>
            <Button disabled={canProceed(error)} onClick={() => { handleAadhaarVerificationOtp(); }} variant="contained" color="success" size="medium" sx={{ width: 260, padding: 1, margin: 2 }}>Next</Button>
          </div>
          )}

        </Paper>
      </Container>
    </Home>
  )
}

export default AadhaarVerification